import useSWR from 'swr';
import { getAssignmentById } from '../../../providers/api/assignment/assignmentProvider';
import { Assignment } from '../../../providers/api/dtos/assignment';
import { useMatchMutate } from '../../../utils/swr/swr';
import { SWRCustomResponse } from '../../../hooks/types';

export const ASSIGNMENT_RID = 'assignment/:id';

export default function useAssignmentById(id?: number): SWRCustomResponse<Assignment> {
  const matchMutate = useMatchMutate();
  const key = id ? [ASSIGNMENT_RID, id] : null;

  const result = useSWR(key, () => getAssignmentById(id!));

  return ({
    ...result,
    mutate: () => matchMutate(ASSIGNMENT_RID),
  }
  );
}
